export const templateTextFormConfig = {
    businessPoint: {
        label: '推广业务',
        tip: '推广业务是您提供的最细粒度的产品或服务，例如语言培训客户，业务可能有“雅思培训”托福培训”“少儿英语”等；如果没有合适的，也支持您自定义输入',
        placeholder: '请输入你的业务点',
        maxlength: 50
    },
    salePoints: {
        label: '卖点',
        tip: '希望在营销文案中突出的产品卖点信息，最多填写3个',
        placeholder: '请简述产品卖点，最多3个关键词，用回车分隔'
    }
};
